import { useId } from "react";

import { LEAD_FORM_ANCHOR_ID, type LeadFormModuleProps } from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

export function LeadFormModule({
  eyebrow,
  heading,
  body,
  layout = "SPLIT",
  submitLabel,
  successMessage,
}: LeadFormModuleProps) {
  const normalizedLayout = layout === "CENTERED" ? "CENTERED" : "SPLIT";
  const isCentered = normalizedLayout === "CENTERED";
  const formId = useId();
  const nameId = `${formId}-name`;
  const phoneId = `${formId}-phone`;
  const emailId = `${formId}-email`;
  const messageId = `${formId}-message`;

  return (
    <section
      id={LEAD_FORM_ANCHOR_ID}
      className={[
        "cms-section",
        "cms-lead-form",
        `cms-lead-form--layout-${isCentered ? "centered" : "split"}`,
      ].join(" ")}
      data-cms-module="lead-form"
    >
      <div className="cms-wrap">
        <div className="cms-lead-form__layout">
          <div className="cms-lead-form__intro">
            {eyebrow ? (
              <div className="cms-eyebrow-row">
                <span className="cms-eyebrow">
                  {renderTextWithLineBreaks(eyebrow)}
                </span>
              </div>
            ) : null}
            {heading ? <h2>{renderTextWithLineBreaks(heading)}</h2> : null}
            {body ? <p>{renderTextWithLineBreaks(body)}</p> : null}
          </div>
          <form
            className="cms-lead-form__form"
            data-cms-lead-form
            data-success-message={
              successMessage ||
              "Thank you. We received your message and will be in touch soon."
            }
          >
            <div className="cms-lead-form__field">
              <label htmlFor={nameId}>Name</label>
              <input
                id={nameId}
                name="name"
                type="text"
                autoComplete="name"
                required
              />
            </div>
            <div className="cms-lead-form__field">
              <label htmlFor={phoneId}>Phone number</label>
              <input
                id={phoneId}
                name="phoneNumber"
                type="tel"
                autoComplete="tel"
                required
              />
            </div>
            <div className="cms-lead-form__field">
              <label htmlFor={emailId}>Email</label>
              <input
                id={emailId}
                name="email"
                type="email"
                autoComplete="email"
                required
              />
            </div>
            <div className="cms-lead-form__field">
              <label htmlFor={messageId}>Message</label>
              <textarea id={messageId} name="message" rows={5} />
            </div>
            <p
              className="cms-lead-form__status"
              data-cms-lead-form-status
              role="status"
              aria-live="polite"
            />
            <button className="cms-btn" type="submit">
              <span>{submitLabel}</span>
              <span className="cms-btn__arrow" aria-hidden="true">
                →
              </span>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
